import dynamic from 'next/dynamic';
import styles from './websiteComponent.module.scss';
import ErrorBoundary from '../errorBoundary/errorBoundary';
// List of dynamically imported components with webpack chunk names
const ComponentList = {
  faq: dynamic(() => import(/* webpackChunkName: "faq" */ '../faq/faq')),
  hiw: dynamic(
    () =>
      import(/* webpackChunkName: "hiwTemplate" */ '../hiwTemplate/hiwTemplate')
  ),
  informativeBanner: dynamic(
    () =>
      import(
        /* webpackChunkName: "informativeBanner" */ '../informativeBanner/informativeBanner'
      )
  ),
  ctaBanner: dynamic(
    () => import(/* webpackChunkName: "ctaBanner" */ '../ctaBanner/ctaBanner')
  ),
  benefits: dynamic(
    () =>
      import(
        /* webpackChunkName: "benefitSection" */ '../benefitSection/benefitSection'
      )
  ),
  productDescription: dynamic(
    () =>
      import(
        /* webpackChunkName: "productDescription" */ '../productDescription/productDescription'
      )
  ),
  prosAndCons: dynamic(
    () =>
      import(/* webpackChunkName: "prosAndCons" */ '../prosAndCons/prosAndCons')
  ),
  hero: dynamic(
    () =>
      import(
        /* webpackChunkName: "heroTemplate" */ '../heroTemplate/heroTemplate'
      )
  ),
  safeAndSecure: dynamic(
    () =>
      import(
        /* webpackChunkName: "safeAndSecureModule" */ '../safeAndSecureModule/safeAndSecureModule'
      )
  ),
  twoColumnTextImage: dynamic(
    () =>
      import(
        /* webpackChunkName: "twoColumnTextImage" */ '../twoColumnTextImage/twoColumnTextImage'
      )
  ),
  socialProof: dynamic(
    () =>
      import(
        /* webpackChunkName: "social-proof" */ '../socialProof/socialProof'
      )
  ),
  comparison: dynamic(
    () =>
      import(
        /* webpackChunkName: "comparisonModule" */ '../comparisonModule/comparisonModule'
      )
  ),
  fullBgCard: dynamic(
    () =>
      import(/* webpackChunkName: "fullBgCard" */ '../fullBgCard/fullBgCard')
  ),
  tabSection: dynamic(
    () =>
      import(
        /* webpackChunkName: "tabModuleMain" */ '../tabModuleMain/tabModuleMain'
      )
  ),
  moreArticlesAndResources: dynamic(
    () =>
      import(
        /* webpackChunkName: "moreArticlesAndResources" */ '../moreArticlesAndResources/moreArticlesAndResources'
      )
  ),
  commonTable: dynamic(
    () =>
      import(
        /* webpackChunkName: "commonTableModule" */ '../commonTableModule/commonTableModule'
      )
  ),
  textModule: dynamic(
    () => import(/* webpackChunkName: "legalText" */ '../legalText/legalText')
  ),
  sgiCalculator: dynamic(
    () =>
      import(
        /* webpackChunkName: "sgiCalculator" */ '../sgiCalculator/sgiCalculator'
      )
  ),
  hubSpotMeet: dynamic(
    () =>
      import(/* webpackChunkName: "hubSpotMeet" */ '../hubSpotMeet/hubSpotMeet')
  ),
  childitem2ColNavigationWrapper: dynamic(
    () =>
      import(
        /* webpackChunkName: "twoColumnLayoutLP" */ '../twoColumnLayoutLP/twoColumnLayoutLP'
      )
  ),
  pageTemplate2Cols: dynamic(
    () =>
      import(
        /* webpackChunkName: "twoColumnLayoutChildPage" */ '../twoColumnLayoutChildPage/twoColumnLayoutChildPage'
      )
  ),
  wildfireSurvey: dynamic(
    () =>
      import(
        /* webpackChunkName: "wildfireSurvey" */ '../wildfireSurvey/wildfireSurvey'
      )
  ),
  heroCreditKarma: dynamic(
    () =>
      import(
        /* webpackChunkName: "heroCreditKarma" */ '../heroCreditKarma/heroCreditKarma'
      )
  ),
  helpCenterListWrapper: dynamic(
    () =>
      import(
        /* webpackChunkName: "helpCenterListWrapper" */ '../helpCenterListWrapper/helpCenterListWrapper'
      )
  ),
  benefitBand: dynamic(
    () =>
      import(/* webpackChunkName: "benefitBand" */ '../benefitBand/benefitBand')
  ),
  wildfireLogin: dynamic(
    () =>
      import(
        /* webpackChunkName: "wildfireLogin" */ '../wildfireLogin/wildfireLogin'
      )
  ),
  heroHome: dynamic(
    () =>
      import(
        /* webpackChunkName: "heroHomeTemplate" */ '../heroHomeTemplate/heroHomeTemplate'
      )
  ),
  heroDeposit: dynamic(
    () =>
      import(/* webpackChunkName: "heroDeposit" */ '../heroDeposit/heroDeposit')
  ),
  bazaarVoiceReview: dynamic(
    () =>
      import(/* webpackChunkName: "bazaarVoice" */ '../bazaarVoice/bazaarVoice')
  ),
  heroMemberLogin: dynamic(
    () =>
      import(
        /* webpackChunkName: "heroMemberLogin" */ '../heroMemberLogin/heroMemberLogin'
      )
  ),
  articleList: dynamic(
    () =>
      import(/* webpackChunkName: "articleList" */ '../articleList/articleList')
  ),
  subNavBar: dynamic(
    () => import(/* webpackChunkName: "subNavBar" */ '../subNavBar/subNavBar')
  ),
  helpCenterSearchBlock: dynamic(
    () =>
      import(
        /* webpackChunkName: "helpCenterSearchBlock" */ '../helpCenterSearchBlock/helpCenterSearchBlock'
      )
  ),
  helpCenterHubGrid: dynamic(
    () =>
      import(
        /* webpackChunkName: "helpCenterGrid" */ '../helpCenterGrid/helpCenterGrid'
      )
  ),
  rateTable: dynamic(
    () =>
      import(/* webpackChunkName: "ratesTable" */ '../ratesTable/ratesTable')
  ),
  cardList: dynamic(
    () => import(/* webpackChunkName: "cardList" */ '../cardList/cardList')
  ),
  extoleTag: dynamic(
    () =>
      import(
        /* webpackChunkName: "extoleTagScript" */ '../extoleTag/extoleTagScript'
      )
  ),
  legService: dynamic(
    () =>
      import(/* webpackChunkName: "legService" */ '../legService/legService')
  ),
  emailCapture: dynamic(
    () =>
      import(
        /* webpackChunkName: "emailCapture" */ '../emailCapture/emailCapture'
      )
  ),
  stickyHeader: dynamic(
    () =>
      import(
        /* webpackChunkName: "stickyHeader" */ '../stickyHeader/stickyHeader'
      )
  ),
  heroCardList: dynamic(
    () =>
      import(
        /* webpackChunkName: "heroCardList" */ '../heroCardList/heroCardList'
      )
  ),
  cardWithTitle: dynamic(
    () =>
      import(
        /* webpackChunkName: "cardWithTitle" */ '../cardWithTitle/cardWithTitle'
      )
  ),
};

export default function WebsiteComponent({
  type,
  data,
  theme,
  isExistingUser,
  isUserLoggedIn,
}) {
  if (!ComponentList[type]) {
    return null;
  }
  const Component = ComponentList[type];
  return (
    <div
      className={`${styles.websiteComponent} ${
        styles[theme ?? 'transparent']
      } ${styles[type] ?? ''} ${
        type === 'stickyHeader' ? styles.stickyHeaderStyle : ''
      }`}
      data-ctype={type}
    >
      <div
        className={
          type !== 'heroCardList' && type !== 'stickyHeader'
            ? styles.container
            : ''
        }
      >
        <div
          className={
            type !== 'heroCardList' && type !== 'stickyHeader'
              ? styles.section
              : ''
          }
        >
          <ErrorBoundary>
            <Component
              {...data}
              isExistingUser={isExistingUser}
              isUserLoggedIn={isUserLoggedIn}
            />
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
}
